// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 610) return "static/chunks/610-4956e5dedb0980c1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 458 ? "b05c4168" : chunkId) + "." + {"279":"5651a2c2478927bd","374":"cf6f5154c39eb05b","450":"fa88f28a59296599","458":"b574286ed8d1934e","466":"499df4f9ab92fa3e","629":"df48a669d9de2458","729":"ef72957692e3d433","953":"cd5d6e915386ed22"}[chunkId] + ".js";
};